module.exports = __webpack_public_path__ + "static/media/bursts_21.660cd7a4.svg";